import { render, staticRenderFns } from "./YamlPlugin.vue?vue&type=template&id=acdd6514&"
import script from "./YamlPlugin.vue?vue&type=script&lang=ts&"
export * from "./YamlPlugin.vue?vue&type=script&lang=ts&"
import style0 from "./YamlPlugin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports